"use client";
import { Dialog, DialogHeader, DialogBody } from "@dxp-feed/ui/Dialog";
import { Box } from "@dxp-feed/ui/Box";
import { useState } from "react";
import ImageWrapper from "@/components/ImageWrapper";
import { ScreenSetComponent } from "@dxp-feed/gigya";
import { GigyaScreenSet } from "@/utils/constant";
import { handlePopupClose } from "@/helpers/sceneCardFunctions";
import { Button, Text } from "@dxp-feed/ui";
import { getFromLocalStorage } from "@/helpers/storageHelper";
import { addDataLayer } from "@/helpers/dataLayer";
import { sendSalesforceInteraction } from "@/helpers/cdnSdk";
import { getUTMParameter } from "@/helpers/getUTMParameters";
import {
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { sceneStatesTrigger } from "@/utils/redux/gigya/scene";
import { RootState } from "@/utils/redux/store";
import { deleteCookie, getCookie } from "cookies-next";
import { flushToken } from "@/helpers/gigyaCentralSsoHook";

const AddSceneCardPopup = ({
  callback,
  disableSuppress,
}: {
  callback?: () => any;
  disableSuppress?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const dispatch = useAppDispatch();
  const closeDialog = () => {
    dispatch(
      sceneStatesTrigger({
        popupType: "",
        suppression: false,
      })
    );
  };
  const region = getFromLocalStorage("storeRegion");
  const userSession = useAppSelector((state) => state.gigyaslice);
  const sceneContent = useAppSelector(
    (state: RootState) => state.sceneContent.items
  );
  // console.log("this is sceneContent",sceneContent)

  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={closeDialog}
        className="xs:max-w-[708px] max-w-full xs:w-full w-[90%] mx-6 outline-none relative pb-2 2xs:h-auto h-[520px] 2xs:overflow-auto overflow-x-scroll"
        closeOnOverlayClick={false}
      >
        <DialogHeader className="justify-end">
          <Button
            aria-label="Close Button"
            className="text-brandBlack text-2xl top-3 right-3 absolute hover:text-gray-800 !bg-brandWhite !before:hidden !border-0 !hover:border-0 !focus:border-0 !hover:bg-brandWhite !focus:bg-brandWhite focus:text-brandBlack"
            onClick={() => {
              if (!disableSuppress) {
                handlePopupClose({
                  cookie: "add_suppress",
                  suppressType: "hard",
                });
              }
              addDataLayer({
                event: "popup_card",
                click_text: "close",
              });
              closeDialog();
              document.body.style.touchAction = "";
            }}
          >
            <Text as="span" className="icon-close flex w-4 text-base" />
          </Button>
        </DialogHeader>
        <DialogBody className="pt-0 pb-0">
          <Box className="flex  md:justify-between justify-center items-center flex-wrap">
            <Box className="xs:w-[250px] w-[150px]">
              <ImageWrapper
                src="/Verify-your-Scene-card.svg"
                className="h-auto"
                alt="verify your Scene+ card"
                width={250}
                height={266}
                style={{}}
              />
            </Box>
            <Box className="md:w-[378px] w-full add-card-screen">
              <h2 className="text-xl pb-4 font-sans font-bold">
                {sceneContent[0]?.title3}
              </h2>
              <ul className="linkpop pb-6 [&>li]:flex [&>li]:text-body [&>li]:items-start [&>li]:gap-2 [&>.icon-check]:before:text-sm [&>.icon-check]:before:px-3 [&>.icon-check]:before:py-1 [&>.icon-check]:before:justify-center [&>.icon-check]:before:flex  [&>.icon-check]:before:content-['\e80d']">
                {sceneContent[0]?.bulletedContent.map(
                  (item: any, index: any) => (
                    <li
                      key={index}
                      className={`icon-check ${index === 1 ? "py-3" : ""}`}
                    >
                      {item}
                    </li>
                  )
                )}
              </ul>
              {/* Render ScreenSetComponent inside the Dialog */}
              <div className="scenePlusform !min-h-[268px]">
                <ScreenSetComponent
                  componentId={"add-card-screen-container"}
                  screenset={GigyaScreenSet.addcardScreen.screenset}
                  page={GigyaScreenSet.addcardScreen.page}
                  context={{
                    region:
                      region ||
                      (process.env.NEXT_PUBLIC_DEFAULT_REGION as string),
                    brand: process.env.NEXT_PUBLIC_DEFAULT_BRAND as string,
                    lang: process.env.NEXT_PUBLIC_DEFAULT_LOCALE as string,
                    homeBanner: process.env
                      .NEXT_PUBLIC_DEFAULT_HOME_BANNER as string,
                    locale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE as string,
                  }}
                />
                <button
                  id="add-card-aftersubmit"
                  className="hidden"
                  aria-label="add card after submit"
                  onClick={async () => {
                    flushToken();
                    closeDialog();
                    if (callback) {
                      addDataLayer({
                        event: "card_activation",
                        click_text: "card_activation",
                        click_url: "success",
                        page_title:
                          typeof window != "undefined" ? document?.title : "",
                      });
                      addDataLayer({
                        event: "scene_registration",
                        click_text: "Add Card",
                        click_url: "step_1",
                        page_title:
                          typeof window != "undefined" ? document?.title : "",
                      });
                      sendSalesforceInteraction({
                        name: "cardActivation",
                        event: "cardActivation",
                        banner: process.env.NEXT_PUBLIC_MERCHANT_IDENTIFIER,
                        isAnonymous: userSession?.uid ? 0 : 1,
                        gigyaUid: userSession?.uid || "",
                        status: "success",
                        cardActivations: "success",
                        utmsource: getUTMParameter("utm_sougce"),
                        utmMedium: getUTMParameter("utm_medium"),
                        utmCampaign: getUTMParameter("utm_campaign"),
                      });
                      await deleteCookie("add_suppress");
                      await deleteCookie("link_suppress");
                      await callback();
                    }
                  }}
                />
                <button
                  aria-label="remind later add card"
                  id="remind-addcard"
                  className="hidden"
                  onClick={() => {
                    closeDialog();
                    addDataLayer({
                      event: "popup_card",
                      click_text: "remind me later",
                    });
                    if (!disableSuppress) {
                      handlePopupClose({
                        cookie: "add_suppress",
                        suppressType: "soft",
                      });
                    }
                  }}
                />
              </div>
            </Box>
          </Box>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default AddSceneCardPopup;
